import { useNavigate } from "react-router-dom";
import { footerData } from "@/mocks/homeData";

export default function Footer() {
  const navigate = useNavigate();

  const handleNavClick = (href: string) => {
    if (href.startsWith("#")) {
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="w-full bg-foreground-950">
      <div className="w-full px-4 md:px-6 lg:px-10 pt-14 md:pt-18 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8 lg:gap-6">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <span className="text-background-50 font-heading font-bold text-sm">RS</span>
              </div>
              <span className="font-heading font-bold text-lg text-background-50">
                {footerData.company}
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed max-w-xs mb-5">
              {footerData.tagline}
            </p>
          </div>

          {footerData.links.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading font-semibold text-xs text-background-50 uppercase tracking-wider mb-4">
                {group.title}
              </h4>
              <ul className="space-y-2">
                {group.items.map((item) => (
                  <li key={item.label}>
                    <a
                      href={item.href}
                      onClick={(e) => {
                        if (item.href.startsWith("#")) {
                          e.preventDefault();
                          handleNavClick(item.href);
                        }
                      }}
                      className="text-sm text-background-400 hover:text-accent-400 transition-colors"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h4 className="font-heading font-semibold text-xs text-background-50 uppercase tracking-wider mb-4">
              Newsletter
            </h4>
            <p className="text-sm text-background-400 mb-3">
              {footerData.newsletter.disclaimer}
            </p>
            <form
              data-readdy-form
              onSubmit={async (e) => {
                e.preventDefault();
                const form = e.currentTarget;
                const formData = new FormData(form);
                const email = (formData.get("email") as string || "").trim();
                if (!email) return;

                const payload = new URLSearchParams();
                payload.append("email", email);

                try {
                  const response = await fetch("https://readdy.ai/api/form/d9nobkkit35ii3jdltu0", {
                    method: "POST",
                    headers: { "Content-Type": "application/x-www-form-urlencoded" },
                    body: payload.toString(),
                  });
                  if (response.ok) {
                    form.reset();
                    alert("Thanks for subscribing!");
                  }
                } catch {
                  alert("Something went wrong. Please try again.");
                }
              }}
              className="flex flex-col gap-2"
            >
              <input
                type="email"
                name="email"
                required
                placeholder={footerData.newsletter.placeholder}
                className="px-3 py-2 rounded-md bg-foreground-800/60 border border-foreground-700/50 text-sm text-background-50 placeholder:text-background-500 focus:outline-none focus:ring-2 focus:ring-primary-400 transition-all"
              />
              <button
                type="submit"
                className="px-4 py-2 text-xs font-semibold rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                {footerData.newsletter.button}
              </button>
            </form>

            <div className="mt-5 pt-5 border-t border-foreground-800/40">
              <div className="flex items-center gap-3 mb-4">
                <a href="#" className="w-8 h-8 rounded-lg bg-foreground-800/60 flex items-center justify-center text-background-400 hover:text-accent-400 hover:bg-foreground-800 transition-colors" aria-label="LinkedIn">
                  <i className="ri-linkedin-fill text-sm" />
                </a>
                <a href="#" className="w-8 h-8 rounded-lg bg-foreground-800/60 flex items-center justify-center text-background-400 hover:text-accent-400 hover:bg-foreground-800 transition-colors" aria-label="Twitter">
                  <i className="ri-twitter-x-fill text-sm" />
                </a>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded bg-accent-500/15 flex items-center justify-center shrink-0">
                  <i className="ri-shield-check-line text-accent-400 text-sm" />
                </div>
                <span className="text-xs text-background-500">Annual Security Assessed</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800/60">
        <div className="w-full px-4 md:px-6 lg:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">{footerData.bottom}</p>
          <div className="flex items-center gap-5">
            <a
              href="/privacy"
              onClick={(e) => { e.preventDefault(); navigate("/privacy"); }}
              className="text-xs text-background-500 hover:text-accent-400 transition-colors"
            >
              Privacy Policy
            </a>
            <a href="#enterprise-trust" onClick={(e) => { e.preventDefault(); handleNavClick("#enterprise-trust"); }} className="text-xs text-background-500 hover:text-accent-400 transition-colors">Terms & Compliance</a>
            <a href="#" className="text-xs text-background-500 hover:text-accent-400 transition-colors">Sitemap</a>
            <a
              href="#home"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick("#home");
              }}
              className="text-xs text-background-500 hover:text-accent-400 transition-colors"
            >
              Back to Top
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}